// The API's TradeSourceType: a block's `source` on /blocks/unassigned (LQC-3094) and on the
// blotter's RP legs (LQC-3241). Manual is one saved from this app.
export enum BlockSource {
  API = "API",
  FIX = "FIX",
  SFTP = "SFTP",
  Manual = "Manual",
}
